/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 17-08-2020.
 */
import React from 'react'

import { animated, easings, useSpring } from '@react-spring/web'
import { useInView } from 'react-intersection-observer'

const FadeUp = ({ className = '', style = {}, children, debug, yposOffSet = 100, delay = 0 }) => {
  const ypos = yposOffSet
  const { ref } = useInView({
    onChange: (inView, entry) => {
      if (entry.boundingClientRect.top < 0) {
        if (entry.isIntersecting) {
          // entered viewport at the top edge, hence scroll direction 0
          api.start({ y: 0, opacity: 1, delay: delay })
        } else {
          // left viewport at the top edge, hence scroll direction is up
          api.start({ y: -ypos, opacity: 0, immediate: true })
        }
      } else {
        //
        // Fadeing up from bottom
        //
        if (entry.isIntersecting) {
          api.start({ y: 0, opacity: 1, delay: delay })
        } else {
          api.start({ y: ypos, opacity: 0, immediate: true })
        }
      }
    },
    /* Optional options */
    //rootMargin: '-110px 0px 110px 0px',
    //rootMargin: '-20px 0px 20px 0px',
    //threshold: 0.2,
    //threshold: 0.1,
    delay: 250, // intersection delay
  })

  const [props, api] = useSpring(() => {
    return {
      from: { y: 100, opacity: 0 },
      to: { y: 0, opacity: 1 },
      //config: { tension: 500, friction: 50, clamp: true },
      config: { easing: easings.easeOutExpo },
    }
  })

  return (
    <animated.div className={className} ref={ref} style={{ ...style, ...props }}>
      {/*<h1 style={{ height: 600 }}>HELLO {debug}</h1>*/}
      {children}
    </animated.div>
  )
}

export default FadeUp
